import { base_url, pieme_base_url, token } from "../utils/constants";

async function postData(data = {}) {
  try {
    const response = await fetch(base_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${token}`,
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify(data), // body data type must match "Content-Type" header
    });

    const resp = await response.json();
    return resp;
  } catch (e) {
    return { success: 0 };
  }
}

export async function postDataAPI(data = {}) {
  try {
    const response = await fetch(pieme_base_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjo1OCwiY29kZSI6IlpaQVFGTExLIiwiZmlyc3RfbmFtZSI6IkFtb2tvIiwibGFzdF9uYW1lIjoiSXZhbiIsInVzZXJuYW1lIjoiaWFtb2tvIiwicHJvZmlsZV9waWMiOm51bGwsImdlbmRlciI6bnVsbCwiYmlydGhfZGF0ZSI6bnVsbCwicGhvbmVfbm8iOjI1NjcwNTUzMTg5OCwiZW1haWxfaWQiOiJhbW9rb2l2YW5AZ21haWwuY29tIiwicmVmZXJyZWRfYnkiOm51bGwsIm5vayI6IkFtb2tvIiwibm9rX3JlbGF0aW9uc2hpcCI6IlNhbWUiLCJub2tfYWRkcmVzcyI6Im5hamplcmEiLCJiZW5lZmljaWFyeSI6Im5hbmlhIiwiYmVuZWZpY2lhcnlfcmVsYXRpb25zaGlwIjoiU29tZXRoaW5nIiwiYmVuZWZpY2lhcnlfYWRkcmVzcyI6Ik5hamplcmEiLCJzaWduYXR1cmUiOiIxNzI4NzMxNTcwOTMxLS1zaWduYXR1cmUucG5nIiwicGFzc3dvcmQiOiI2YzBhMGY1OTFkMmY2MTc3N2I0MTU0Zjg2MDQ2MmRkOCIsInZlcmlmaWNhdGlvbl9zdGF0dXMiOjAsIm1vYmlsZV9jb2RlIjowLCJpc192ZXJpZnkiOjAsImRldmljZV90eXBlIjoiIiwiZGV2aWNlX2lkIjpudWxsLCJpc19ibG9ja2VkIjowLCJwdXNoX2VuYWJsZSI6MSwiaXNfdmlicmF0ZSI6MSwiaXNfZGVsZXRlZCI6MCwiaXNfb25saW5lIjoxLCJmcm9tX2FueW9uZSI6MCwiaXNfdHlwaW5nIjowLCJsYXN0X2xvZ2luIjoiMjAyNS0wNC0xNVQwODowOTozNS4wMDBaIiwiY3JlYXRpb25fZGF0ZXRpbWUiOiIyMDI0LTA2LTIzVDIwOjAzOjU0LjAwMFoiLCJtb2RpZmljYXRpb25fZGF0ZXRpbWUiOiIyMDI0LTA2LTIzVDIwOjAzOjU0LjAwMFoiLCJpYXQiOjE3NjQ2ODEyNDd9.yIqRWeD0qmfsq8PCVvrTW2__RUWo4qVeENX10pZleAw`,
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify(data), // body data type must match "Content-Type" header
    });

    const resp = await response.json();
    return resp;
  } catch (e) {
    return { success: 0 };
  }
}

export async function postAuthData(data = {}) {
  try {
    const response = await fetch(pieme_base_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify(data), // body data type must match "Content-Type" header
    });

    const resp = await response.json();
    return resp;
  } catch (e) {
    return { success: 0 };
  }
}

export default postData;
